import { render } from "./FichaSaida.vue?vue&type=template&id=3390c6e3&scoped=true"
import script from "./FichaSaida.vue?vue&type=script&lang=js"
export * from "./FichaSaida.vue?vue&type=script&lang=js"

import "./FichaSaida.vue?vue&type=style&index=0&id=3390c6e3&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3390c6e3"]])

export default __exports__